import type { Route, RouteResources } from '@atlassian/react-resource-router/src/common/types.tsx';
import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { createRouteEntry } from './createRouteEntry.tsx';

type LegacyEntryOptions<T> = Partial<LegacyEntryRoute<T>> &
	Partial<Record<keyof InvariantJiraRoute, never>>;

/** A legacy route may load a root that retains its existing non-SPA lifecycle. */
export type LegacyEntryRoute<T> = Omit<JiraLegacyRoute<T>, 'lazyOpts'> &
	Pick<Route, 'component' | 'entryPoint' | 'entryPointContainer' | 'entryPointOptions'> & {
		lazyOpts?: () => LegacyEntryOptions<T>;
	};

/**
 * Create a route entry for legacy pages.
 */
export const createLegacyEntry: (
	baseRoute: InvariantJiraRoute,
	opts: () => LegacyEntryOptions<RouteResources>,
) => LegacyEntryRoute<RouteResources> = createRouteEntry<
	InvariantJiraRoute,
	LegacyEntryOptions<RouteResources>,
	LegacyEntryRoute<RouteResources>
>;
